import React from 'react';
import PropTypes from 'prop-types';
import { GlassMagnifier } from 'react-image-magnifiers';
import styles from './BeforeAfter.module.sass';

function BeforeAfter(props) {
  const { images } = props;

  return (
    <div className={styles.images}>
      {images.map((image) => (
        <GlassMagnifier
          imageSrc={image.src}
          square
          magnifierSize="50%"
          largeImageSrc={image.src}
        />
      ))}
    </div>
  );
}

BeforeAfter.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string.isRequired,
  })).isRequired,
};

export default BeforeAfter;
